module.exports = __webpack_public_path__ + "images/assets/4a59359056a34335063840047cc4784a.svg";